import React, {Component} from 'react'
import injectSheet from 'react-jss'

import HeaderText from './header-text'

const styles = {
  minicard: {
    display: 'flex',
    flexFlow: 'column',
    width: 'calc(33.33vw - 3em)',
    backgroundColor: 'white',
    borderTop: '8px solid #F37B1D',
    minWidth: '160px',
    margin: '1em',
    padding: '1em',
    '@media (max-width: 1080px)': {
      width: 'calc(50vw - 3em)'
    },
    '@media (max-width: 767px)': {
      width: 'calc(100vw - 4em)'
    },
    '@media (min-width: 768px)': {
      maxWidth: '360px'
    }
  },
  image: {
    width: 'calc(33.33vw - 5em)',
    height: 'calc(33.33vw - 5em)',
    backgroundSize: 'cover',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
    marginBottom: '1em',
    minWidth: '128px',
    minHeight: '128px',
    '@media (max-width: 1080px)': {
      width: 'calc(50vw - 5em)',
      height: 'calc(50vw - 5em)'
    },
    '@media (max-width: 767px)': {
      width: 'calc(100vw - 7em)',
      height: 'calc(100vw - 6em)',
    },
    '@media (min-width: 768px)': {
      maxWidth: 'calc(360px - 2em)',
      maxHeight: 'calc(360px - 2em)',
    }
  },
  description: {
    color: 'black',
    fontSize: '1em'
  }
}

class MiniCard extends Component {
  render() {
    const {classes, image, video, title, description, children} = this.props
    return(
      <div className={classes.minicard}>
        {image && <div className={classes.image} style={{backgroundImage: 'url(' + image + ')'}}/>}
        {video && <iframe className={classes.image} src={`https://www.youtube.com/embed/${video}`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>}
        <HeaderText dark small>{title}</HeaderText>
        <h3 className={classes.description}>{description||children}</h3>
      </div>
    )
  }
}

export default injectSheet(styles)(MiniCard)
